export function getStaticMap(params: {
  lat?: number;
  lon?: number;
  zoom?: number;
  width?: number;
  height?: number;
  line?: [[number, number], [number, number]];
  markers?: [number, number][];
}) {
  const baseUrl = "https://staticmap.app";
  const searchParams = new URLSearchParams({});

  if (params.lat && params.lon) {
    searchParams.append("center", `${params.lat},${params.lon}`);
  }
  if (params.zoom) searchParams.append("z", `${params.zoom}`);
  if (params.width) searchParams.append("w", `${params.width}`);
  if (params.height) searchParams.append("h", `${params.height}`);
  if (params.line) {
    searchParams.append(
      "line[0]",
      `color:%23000000|width:2|coords:${encodeURI(
        `${params.line.map((point) => point.join(",")).join(";")}`,
      )}`,
    );
  }

  for (let i = 0; i < (params.markers || []).length; i++) {
    searchParams.append(
      `marker[${i}]`,
      `color:%23ff0000|diam:7|coords:${params.markers![i].join(",")}`,
    );
  }

  return `${baseUrl}?${decodeURIComponent(searchParams.toString())}`;
}
